// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list[data-v-a0e3a36a] {\n  justify-content: flex-start;\n}", ""]);
// Exports
module.exports = exports;
